export const css = {
	root: '_3xW6DeSN',
	heading: '_9zqiie6-',
	article: '_1hShKUSL',
	' _key': 'certwise-theme/certwise/lcc-rcs/document'
};

export default css;
